export interface SingularPluralString {
    singular: string;
    firstPlural: string;
    secondPlural: string;
    simplifiedPlural: string | undefined;
}

/** Creates an object that represent the different forms of a unit's suffix */
export default function createSingularPluralStrings(singular: string, firstPlural: string, secondPlural: string, simplifiedPlural?: string): SingularPluralString {
    return {
        singular,
        firstPlural,
        secondPlural,
        simplifiedPlural,
    };
}
